import { Data } from '@angular/router'
import { MenuAction, MenuResourceCode, PermissionRouteData } from '@core-entities/auth.entity'

const validMenuActions = new Set<MenuAction>(['create', 'delete', 'edit', 'view'])

export const permissionRouteData = (
  resourceCode: MenuResourceCode,
  requiredAction: MenuAction = 'view',
): PermissionRouteData => ({
  resourceCode,
  requiredAction,
})

export const permissionRouteDataAny = (
  resourceCodes: MenuResourceCode[],
  requiredAction: MenuAction = 'view',
): PermissionRouteData => ({
  anyResourceCodes: resourceCodes,
  requiredAction,
})

export const readPermissionRouteData = (data: Data | undefined): PermissionRouteData => {
  if (!data) return {}

  const resourceCode = typeof data['resourceCode'] === 'string' ? (data['resourceCode'] as MenuResourceCode) : undefined
  const anyResourceCodes = Array.isArray(data['anyResourceCodes'])
    ? data['anyResourceCodes'].filter((value): value is MenuResourceCode => typeof value === 'string')
    : undefined
  const requiredAction = data['requiredAction']

  return {
    resourceCode,
    anyResourceCodes: anyResourceCodes?.length ? anyResourceCodes : undefined,
    requiredAction:
      typeof requiredAction === 'string' && validMenuActions.has(requiredAction as MenuAction)
        ? (requiredAction as MenuAction)
        : undefined,
  }
}
